export const chileTerritory = [
  {
    region: 'Arica y Parinacota',
    codigoGeoJSON: 15,
    lat: -18.4783,
    lng: -70.3126,
    comunas: [
      'Arica',
      'Camarones',
      'Putre',
      'General Lagos'
    ]
  },

  {
    region: 'Tarapacá',
    codigoGeoJSON: 1,
    lat: -20.2133,
    lng: -70.1503,
    comunas: [
      'Iquique',
      'Alto Hospicio',
      'Pozo Almonte',
      'Camiña',
      'Colchane',
      'Huara',
      'Pica'
    ]
  },

  {
    region: 'Antofagasta',
    codigoGeoJSON: 2,
    lat: -23.6509,
    lng: -70.3975,
    comunas: [
      'Antofagasta',
      'Mejillones',
      'Sierra Gorda',
      'Taltal',
      'Calama',
      'Ollagüe',
      'San Pedro de Atacama',
      'Tocopilla',
      'María Elena'
    ]
  },

  {
    region: 'Atacama',
    codigoGeoJSON: 3,
    lat: -27.3668,
    lng: -70.3323,
    comunas: [
      'Copiapó',
      'Caldera',
      'Tierra Amarilla',
      'Chañaral',
      'Diego de Almagro',
      'Vallenar',
      'Freirina',
      'Huasco',
      'Alto del Carmen'
    ]
  },

  {
    region: 'Coquimbo',
    codigoGeoJSON: 4,
    lat: -29.9533,
    lng: -71.3436,
    comunas: [
      'La Serena',
      'Coquimbo',
      'Andacollo',
      'La Higuera',
      'Paihuano',
      'Vicuña',
      'Illapel',
      'Canela',
      'Los Vilos',
      'Salamanca',
      'Ovalle',
      'Combarbalá',
      'Monte Patria',
      'Punitaqui',
      'Río Hurtado'
    ]
  },

  {
    region: 'Valparaíso',
    codigoGeoJSON: 5,
    lat: -33.0472,
    lng: -71.6127,
    comunas: [
      'Valparaíso',
      'Viña del Mar',
      'Concón',
      'Quilpué',
      'Villa Alemana',
      'Casablanca',
      'Quintero',
      'Puchuncaví',
      'San Antonio',
      'Cartagena',
      'El Quisco',
      'El Tabo',
      'Algarrobo',
      'Santo Domingo',
      'San Felipe',
      'Catemu',
      'Llaillay',
      'Panquehue',
      'Putaendo',
      'Santa María',
      'Los Andes',
      'Calle Larga',
      'Rinconada',
      'San Esteban',
      'La Calera',
      'Nogales',
      'Hijuelas',
      'Quillota',
      'La Cruz',
      'Limache',
      'Olmué'
    ]
  },

  {
    region: 'Metropolitana',
    codigoGeoJSON: 13,
    lat: -33.4489,
    lng: -70.6693,
    comunas: [
      'Santiago',
      'Providencia',
      'Las Condes',
      'Vitacura',
      'Lo Barnechea',
      'Ñuñoa',
      'Maipú',
      'Puente Alto',
      'San Bernardo',
      'La Florida',
      'Peñalolén',
      'Recoleta',
      'Independencia',
      'Estación Central',
      'Quilicura',
      'Pudahuel',
      'Cerrillos',
      'Colina',
      'Lampa',
      'Tiltil'
    ]
  },

  {
    region: 'O’Higgins',
    codigoGeoJSON: 6,
    lat: -34.1708,
    lng: -70.7444,
    comunas: [
      'Rancagua',
      'Machalí',
      'San Fernando',
      'Santa Cruz',
      'Pichilemu',
      'Rengo',
      'Graneros',
      'Mostazal'
    ]
  },

  {
    region: 'Maule',
    codigoGeoJSON: 7,
    lat: -35.4264,
    lng: -71.6554,
    comunas: [
      'Talca',
      'Curicó',
      'Linares',
      'Cauquenes',
      'Constitución',
      'Parral',
      'Molina',
      'San Javier'
    ]
  },

  {
    region: 'Ñuble',
    codigoGeoJSON: 16,
    lat: -36.6063,
    lng: -72.1034,
    comunas: [
      'Chillán',
      'Chillán Viejo',
      'San Carlos',
      'Bulnes',
      'Quirihue'
    ]
  },

  {
    region: 'Biobío',
    codigoGeoJSON: 8,
    lat: -36.8201,
    lng: -73.0444,
    comunas: [
      'Concepción',
      'Talcahuano',
      'Coronel',
      'Lota',
      'Los Ángeles',
      'Mulchén',
      'Nacimiento',
      'Arauco',
      'Curanilahue'
    ]
  },

  {
    region: 'La Araucanía',
    codigoGeoJSON: 9,
    lat: -38.7359,
    lng: -72.5904,
    comunas: [
      'Temuco',
      'Padre Las Casas',
      'Villarrica',
      'Pucón',
      'Angol',
      'Victoria'
    ]
  },

  {
    region: 'Los Ríos',
    codigoGeoJSON: 14,
    lat: -39.8142,
    lng: -73.2459,
    comunas: [
      'Valdivia',
      'La Unión',
      'Río Bueno',
      'Panguipulli'
    ]
  },

  {
    region: 'Los Lagos',
    codigoGeoJSON: 10,
    lat: -41.4693,
    lng: -72.9424,
    comunas: [
      'Puerto Montt',
      'Puerto Varas',
      'Osorno',
      'Castro',
      'Ancud',
      'Quellón'
    ]
  },

  {
    region: 'Aysén',
    codigoGeoJSON: 11,
    lat: -45.5712,
    lng: -72.0685,
    comunas: [
      'Coyhaique',
      'Puerto Aysén',
      'Chile Chico',
      'Cochrane'
    ]
  },

  {
    region: 'Magallanes',
    codigoGeoJSON: 12,
    lat: -53.1638,
    lng: -70.9171,
    comunas: [
      'Punta Arenas',
      'Puerto Natales',
      'Porvenir',
      'Puerto Williams'
    ]
  }
];